import {
  ConsentTemplateFormData,
  ConsentTemplateInputData,
} from '@/features/dashboard/consentTemplates/schemas/consentTemplateSchema.ts';
import { ConsentTemplateDto } from '@/features/dashboard/consentTemplates/types/ConsentTemplateDto.ts';
import { ConsentType } from '@/features/dashboard/consentTemplates/types/ConsentTemplateType.ts';
import { FileAction } from '@/schemas/fileFieldSchema.ts';

function ensureHttps(url: string): string {
  if (/^https?:\/\//.test(url)) return url;
  return `https://${url}`;
}

export const consentTemplateMapper = {
  fromFormToDto(form: ConsentTemplateFormData): ConsentTemplateDto {
    switch (form.type) {
      case ConsentType.TEMPLATE:
        return {
          type: ConsentType.TEMPLATE,
          name: form.name,
          documentTemplate: form.documentTemplate,
        };
      case ConsentType.LINK:
        return {
          type: ConsentType.LINK,
          name: form.name,
          linkUrl: ensureHttps(form.linkUrl),
        };
      case ConsentType.FILE:
        return {
          type: ConsentType.FILE,
          name: form.name,
          fileId: form.consentFile.fileId,
        };
    }
  },

  fromDtoToForm(dto: ConsentTemplateDto): ConsentTemplateInputData {
    switch (dto.type) {
      case ConsentType.TEMPLATE:
        return {
          type: ConsentType.TEMPLATE,
          name: dto.name,
          documentTemplate: dto.documentTemplate,
        };
      case ConsentType.LINK:
        return {
          type: ConsentType.LINK,
          name: dto.name,
          linkUrl: dto.linkUrl,
        };
      case ConsentType.FILE:
        return {
          type: ConsentType.FILE,
          name: dto.name,
          consentFile: {
            action: FileAction.NO_ACTION,
            fileId: dto.fileId ?? undefined,
            fileUrl: dto.downloadUrl ?? undefined,
          },
        };
    }
  },
};
